import { PanelModeContext } from './AIAssistantProvider';
import { useContext } from 'react';

export default function usePanelMode() {
    const context = useContext(PanelModeContext);
    if (context === null) {
        throw new Error('usePanelMode must be used within an <AIAssistantProvider>');
    }
    return context;
}
